import { computed } from "vue";
import type { Ref, ComputedRef } from "vue";

/**
 * メタタグ情報
 */
export interface MetaTagOptions {
  headTitle: Ref<string | undefined>;
  headDescription: Ref<string | undefined>;
  ogpUrl: Ref<string | undefined>;
  ogpImage: Ref<string | undefined>;
  noIndex: Ref<boolean | null | undefined>;
}

/**
 * 共通のmetaタグ配列を生成するcomposable
 * @param options MetaTagOptions
 * @returns ComputedRef<{ name?: string; property?: string; content: string | undefined }[]>
 */
export function useMetaTags(
  options: MetaTagOptions,
): ComputedRef<{ name?: string; property?: string; content: string | undefined }[]> {
  return computed(() => {
    const tags = [
      { name: "description", content: options.headDescription.value },
      { property: "og:url", content: options.ogpUrl.value },
      { property: "og:title", content: options.headTitle.value },
      { property: "og:description", content: options.headDescription.value },
      { property: "og:image", content: options.ogpImage.value },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "ja_JP" },
      { property: "og:site_name", content: "Fincs" },
    ];
    if (options.noIndex.value !== null && options.noIndex.value !== undefined) {
      tags.push({
        name: "robots",
        content: options.noIndex.value ? "noindex, nofollow" : "index, follow",
      });
    }
    return tags;
  });
}
